import Image from 'next/image';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { PricingListStyle } from '../../styles/components/country';
import { Button } from '../common/ui';

export interface IPricingListItemProps {
  title: string;
  description: string;
  button: { text: string; link?: string; action?: () => void };
  priceLabel: string;
  startPriceLabel: string;
  endPriceLabel?: string;
  footerText?: string;
  isHighlighted?: boolean;
  reversedPricing?: boolean;
}

export interface IPricingListProps {
  items: IPricingListItemProps[];
}

const PricingList = (props: IPricingListProps) => {
  const router = useRouter();

  return (
    <div className={PricingListStyle['pricing-list']}>
      {props.items.map((item, index) => (
        <div
          key={index}
          className={`${PricingListStyle['pricing-list-item']} ${
            item.isHighlighted
              ? PricingListStyle['pricing-list-item-highlighted']
              : ''
          }`}>
          <ReactMarkdown components={{ p: 'h2' }}>{item.title}</ReactMarkdown>
          <p className={PricingListStyle['pricing-list-item-description']}>
            {item.description}
          </p>
          <div className={PricingListStyle['pricing-list-item-price']}>
            {!item.reversedPricing && (
              <>
                <span>{item.startPriceLabel}</span>{' '}
                <strong>{item.priceLabel}</strong>
              </>
            )}{' '}
            {item.reversedPricing && (
              <>
                <strong>{item.priceLabel}</strong>{' '}
                <span>{item.startPriceLabel}</span>
              </>
            )}{' '}
            <p>{item.endPriceLabel}</p>
          </div>
          <div className={PricingListStyle['pricing-list-item-actions']}>
            <div className={PricingListStyle['pricing-list-item-button']}>
              <Button
                color={item.isHighlighted ? 'cta-primary' : 'cta-gray'}
                hasIcon={true}
                onClick={() => {
                  if (item.button.link) {
                    router.push(item.button.link);
                  }

                  if (item.button.action) {
                    item.button.action();
                  }
                }}>
                {item.button.text}
                <Image
                  quality={90}
                  src={
                    item.isHighlighted
                      ? '/assets/images/icons/ChevronRightWhite.svg'
                      : '/assets/images/icons/ChevronRight.svg'
                  }
                  alt={'action-button'}
                  width={16}
                  height={16}
                />
              </Button>
            </div>
            {item.footerText && (
              <ReactMarkdown
                className={PricingListStyle['pricing-list-item-footer']}>
                {item.footerText}
              </ReactMarkdown>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PricingList;
